<template>
<div style="min-height: 75vh;" class="bg-white">

     <kinesis-container id="banner_thankyou" class="position-relative overflow-hidden">
            <div class="d-none d-md-flex justify-content-center ">
                <kinesis-element :strength="10" class="position-absolute">
                    <img class="w-100" style="transform: scale(1.05); max-width: 1440px;" src="images/scene_back.jpg"
                        alt="Qualität braucht Experten">
                </kinesis-element>
                <kinesis-element :strength="10">
                    <img class="w-100" style="transform: scale(1.05); max-width: 1440px;" src="images/scene_front.png"
                        alt="Qualität braucht Experten">
                </kinesis-element>
            </div>
            <div class="d-md-none w-100">
                <img class="w-100" src="images/banner_mobile.jpg" alt="Qualität braucht Experten">
            </div>
        </kinesis-container>
   <div class="container px-5 px-md-0">
            <div class="row">
                <div class="col">
                    <p class="text-blue font-weight-bold py-4 m-0">Thank you!</p>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex justify-content-center">
                    <div class="headline-strong-1 my-4 font-weight-bold">REGISTRATION CONFIRMED</div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p>
                        Your Registration for our list has been confirmed.
                        <br />
                    </p>
                    <div class="d-none d-md-block">
                        <a href="/" class="link d-inline-flex justify-content-center" style="line-height:1rem">
                            <img src="images/arrow-left.svg" width="25" alt="Zurück">
                            Back
                        </a>
                    </div>
                </div>

            </div>

        </div>
</div>
</template>

<style lang="scss" scoped>
@import 'resources/sass/_variables.scss';

    #banner_thankyou {
        /* background-color: #a2c7e6; */
        background: linear-gradient(90deg, #93bcde 50%, #a2c7e6 50%);
    }


    .link {
        color: $black;
        font-weight: 700;
        text-decoration: none;
    }

    .link>img {
        margin-right: 5px;
        transition: all 0.2s ease-in-out;
    }

    .link:active>img {
        margin-right: 8px;
    }



</style>

<script>
 import {
        KinesisContainer,
        KinesisElement
    } from 'vue-kinesis'
    export default {
        mounted() {
   
        },

    }
</script>
